import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Router, Route } from "wouter";
import { ClerkProvider } from "@clerk/react";
import * as Sentry from "@sentry/react";
import { PhaseRoutes } from "./routes.js";
import { WithListCache } from "./components.js";
import { getRoutes } from "./route_registry.js";
import { TooltipProvider } from "@/components/ui/tooltip";
import { NuqsAdapter } from "nuqs/adapters/react";
import "./all_ext.js";

declare const SCANTLING_FRONTEND_DSN: string;
declare const SCANTLING_ENV: string;

Sentry.init({
  dsn: SCANTLING_FRONTEND_DSN,
  environment: SCANTLING_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  enableLogs: true,
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

declare const CLERK_PUBLISHABLE_KEY: string;

function RegistryRoutes() {
  const routes = getRoutes();
  return (
    <>
      {routes.map(route => (
        <Route key={route.type} path={route.path} component={route.component} />
      ))}
    </>
  );
}

function App() {
  return (
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
        <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
          <NuqsAdapter>
            <TooltipProvider>
              <WithListCache>
                <Router>
                  <RegistryRoutes />
                  <PhaseRoutes />
                </Router>
              </WithListCache>
            </TooltipProvider>
          </NuqsAdapter>
        </ClerkProvider>
      </Sentry.ErrorBoundary>
    </StrictMode>
  );
}

const root = createRoot(document.getElementById("root")!);
root.render(<App />);
